"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.LifecycleAction = exports.LiveStreamState = exports.DescriptorMimeType = exports.MediaType = exports.FileType = exports.ACL = exports.OrderDirection = void 0;
var OrderDirection;
(function (OrderDirection) {
    OrderDirection[OrderDirection["None"] = 0] = "None";
    OrderDirection["ASC"] = "asc";
    OrderDirection["DES"] = "des";
})(OrderDirection = exports.OrderDirection || (exports.OrderDirection = {}));
var ACL;
(function (ACL) {
    ACL["PRIVATE"] = "private";
    ACL["PUBLIC"] = "public";
})(ACL = exports.ACL || (exports.ACL = {}));
var FileType;
(function (FileType) {
    FileType["FILE"] = "-";
    FileType["FOLDER"] = "d";
})(FileType = exports.FileType || (exports.FileType = {}));
var MediaType;
(function (MediaType) {
    MediaType["Image"] = "image";
    MediaType["Video"] = "video";
    MediaType["Audio"] = "audio";
    MediaType["Font"] = "font";
})(MediaType = exports.MediaType || (exports.MediaType = {}));
var DescriptorMimeType;
(function (DescriptorMimeType) {
    DescriptorMimeType["Folder"] = "application/vnd.wix-media.dir";
})(DescriptorMimeType = exports.DescriptorMimeType || (exports.DescriptorMimeType = {}));
var LiveStreamState;
(function (LiveStreamState) {
    LiveStreamState["CREATED"] = "created";
    LiveStreamState["STREAMING"] = "streaming";
    LiveStreamState["PENDING_RECONNECT"] = "pending_reconnect";
    LiveStreamState["DVR_PROCESSING"] = "dvr_processing";
    LiveStreamState["CLOSED"] = "closed";
})(LiveStreamState = exports.LiveStreamState || (exports.LiveStreamState = {}));
var LifecycleAction;
(function (LifecycleAction) {
    LifecycleAction["Delete"] = "delete";
})(LifecycleAction = exports.LifecycleAction || (exports.LifecycleAction = {}));
//# sourceMappingURL=media-platform.js.map